import { render } from "./GroupManagementAssignUsersDialog.vue?vue&type=template&id=650066fe"
import script from "./js/groupManagementAssignUsersDialog.js?vue&type=script&lang=js&external"
export * from "./js/groupManagementAssignUsersDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__